export default {
    download: '点击下载',
    Copyright: '版权所有',
    updateDate: "更新日期",
    company:"其域创新",
    app:'LixelGO',
    version:"1.1.5",
    updateTime: "2024.11.26",
    apk:'https://cdn-bukbv1.xgrids.cloud/prd/lixel/app/LixelGo_android/LG_115_20241126.apk',
    tip:'请使用手机自带浏览器打开',
    tip1:'LCC Scan',
}